export default __webpack_public_path__ + "static/portfolio_gallery_31-f885d12e16c05cedac715ac8ca98ffa3.jpg";